<template>
    <div class="container" v-title="text.title">
        <Navigation-bar></Navigation-bar>
        <div class="container_content">
            <Title :title="text.title" :subtitle="text.subtitle"></Title>
            <div id="MySuperior">
                <div class="content">
                    <ul>
                        <li>
                            <div class="item-input">
                                <input type="text" v-model.trim="name" @input="nameInput" :placeholder="text.placeholder">
                                <div class="list" v-show="list.length > 0">
                                    <div class="list_scroll">
                                        <ol>
                                            <li v-for="(item,index) in list" :key="index" 
                                                @click="selectUnit(item.CompanyName,item.CompanyId)"
                                                v-html="textSign(item.CompanyName)"
                                            ></li>
                                        </ol>
                                        <p class="load_more" v-show="loadMore">{{loadMore}}</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="operation">
                    <button @click="send()">完成</button>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import { mapGetters } from 'vuex';
import $ from 'jquery';
import {
    GetCompanyListAsEmployer,
    GetCompanyListAsParent,
    SetUserEmployedCompany,
    SetCompanyParentCompany
} from "@/api"
export default {
    name:"MySuperior",
    data(){
        return {
            Id:0,
            name: this.$route.params.name || '',
            list:[],
            lastId:0,
            loadMore:'',
            isGetData:true
        }
    },
    mounted(){
        var _this = this;
        $('.list .list_scroll').scroll(function () {
            var scroll = $('.list .list_scroll').scrollTop(),
                h = $('.list .list_scroll').innerHeight(),
                cH = $('.list .list_scroll ol').height();
            if(cH < scroll + h + 4){
                if(!this.isGetData){ 
                    return ;
                }
                this.getListData(1,_this.name);
            }
        });
    },
    computed:{
        ...mapGetters(['UserType']),
        text:function(){
            if(this.UserType == 1){
                return {
                    title:"我的单位",
                    subtitle:"填写我的所属单位",
                    placeholder:'请输入您的单位名称'
                };
            }else {
                return {
                    title:"上级单位",
                    subtitle:"填写机构上级单位",
                    placeholder:'请输入上级单位名称'
                };
            }
        }
    },
    methods:{
        textSign(msg){
            var _this = this;
            const reg = new RegExp(this.name,'gi');
            return msg.replace(reg,(matching)=>{
                return `<i style="font-style: normal;color: ${_this.UserType==1?'#7AD21A':'#FFA61C'};">${matching}</i>`;
            });
        },
        selectUnit(name,Id){
            this.name = name;
            this.Id = Id;
            this.list = [];
            this.lastId = 0;
            this.loadMore = '';
        },
        nameInput(){
            this.Id = 0;
            if(this.name){
                this.getListData(1,this.name);
            }else{
                this.list = [];
            }
        },
        getListData(type,name){
            if(type == 1){
                this.lastId = 0;
                this.list = [];
            }
            this.isGetData = false;
            this.loadMore = '正在查询···';
            if(this.UserType == 1){
                GetCompanyListAsEmployer({
                    "Keyword": name,
                    "Continuation": {
                        "LastId": this.lastId,
                        "MaxCount": 10
                    }
                }).then(data=>{
                    if(name == this.name){
                        this.isGetData = true;
                        this.loadMore = '';
                        if(data.Code == 0 ){
                            if(data.ContinuedList.length > 0){
                                this.list = data.ContinuedList;
                                this.lastId = data.ContinuedList[data.ContinuedList.length-1].CompanyId;
                            }else{
                                this.list = [];
                                this.lastId = 0;
                            }
                        }
                    }
                }).catch(()=>{
                    if(name == this.name){
                        this.isGetData = true;
                        this.loadMore = '';
                    }
                })
            }else{
                GetCompanyListAsParent({
                    "Keyword": name,
                    "Continuation": {
                        "LastId": this.lastId,
                        "MaxCount": 10
                    }
                }).then(data=>{
                    if(name == this.name){
                        this.isGetData = true;
                        this.loadMore = '';
                        if(data.Code == 0 ){
                            if(data.ContinuedList.length > 0){
                                this.list = data.ContinuedList;
                                this.lastId = data.ContinuedList[data.ContinuedList.length-1].CompanyId;
                            }else{
                                this.list = [];
                                this.lastId = 0;
                            }
                        }
                    }
                }).catch(()=>{
                    if(name == this.name){
                        this.isGetData = true;
                        this.loadMore = '';
                    }
                })
            }
        },
        send(){
            if(this.UserType == 2 && this.name != '' && this.Id == 0){
                this.$Toast('请选择上级单位','error');
            }else{
                if(this.UserType == 1){
                    SetUserEmployedCompany({
                        EmployedCompanyId: this.Id,
                        EmployedCompanyName: this.name
                    }).then(data=>{
                        if(data.Code == 0){
                            this.$Toast('修改成功','success');
                            setTimeout(()=>{
                                this.$navigation.back();
                            },1000)
                        }
                    })
                }else{
                    SetCompanyParentCompany({
                        ParentCompanyId: this.Id
                    }).then(data=>{
                        if(data.Code == 0){
                            if(this.Id > 0){
                                this.$Toast('修改成功','success');
                            }else{
                                this.$Toast('已解除您的上级单位','success');
                            }
                            setTimeout(()=>{
                                this.$navigation.back();
                            },1000)
                        }
                    })
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#MySuperior {
    .content{
        height: 700px;
        padding-top: 40px;
        ul{
            >li{
                width: 670px;
                margin: 0 auto;
                margin-bottom: 32px;
                .item-input{
                    width: 670px;
                    height: 108px;
                    position: relative;
                    input{
                        width: 100%;
                        height: 100%;
                        background: #F9F9F9;
                        border-radius: 20px;
                        padding: 0 32px;
                        font-size: 32px;
                        box-sizing: border-box;
                        position: relative;
                        z-index: 2;
                    }
                }
            }
        }
        .list{
            width: 100%;
            height: auto;
            padding: 78px 0 24px;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow: 0 10px 13px -2px rgba(136,136,136,0.15);
            border-radius: 0 0 20px 20px;
            position: absolute;
            top: 54px;
            left: 0;
            .list_scroll{
                width: 100%;
                max-height: 462px;
                overflow-y: auto;
            }
            ol{
                width: 100%;
                li{
                    height: 72px;
                    width: 100%;
                    padding: 0 32px;
                    box-sizing: border-box;
                    @include ellipsis;
                    line-height: 72px;
                    font-size: 28px;
                    color: #8B8C8D;
                    font-weight: 400;
                }
            }
        }
    }
    .operation{
        height: 92px;
        width: 100%;
        button{
            @include btn-type-large;
            background: #F5F7F5;
            color: #1B1C1E;
        }
    }
}
</style>